import { IFilter } from "../../../../context/filters";

export const isFilterNotSortable = (filter: IFilter): boolean => !filter.sortable;
